import React, { useEffect, useState } from 'react';

import { Typography, notification, Modal, Button, Divider } from 'antd';

import { FormattedMessage, useIntl } from 'react-intl';

import "./index.less";

import Core from "../../../../../../common/Core";

import _service from '@netuno/service-client';

const { Text, Title } = Typography;

const langContext = 'reserved-area.marketplace.service';

export default ({ uid, onClose }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);

    useEffect(() => {
        if (uid) {
            setLoading(true);
            _service({
                method: 'GET',
                url: '/marketplace/service',
                data: {
                    uid: uid,
                },
                success: (response) => {
                    setData(response.json);
                    setLoading(false);
                },
                fail: (e) => {
                    setLoading(false);
                    notification['error']({
                        message: 'Não foi possivel carregar os dados.',
                        description: e.response.json.error,
                    });
                }
            });
        }
    }, []);

    const intl = useIntl();

    const onShowModal = () => {
        setIsModalVisible(true);
    };

    return (
        <div className="services-modal">
            <>
                <Modal
                    title={intl.formatMessage({ id: langContext + '.fields.service' })}
                    visible={true}
                    onCancel={onClose}
                    footer={[
                        <Button type='primary' onClick={onClose}>
                            <FormattedMessage id={`${langContext}.button.close`} />
                        </Button>]}
                >
                    <Title level={4}><FormattedMessage id={`${langContext}.fields.details`} /></Title>
                    <p><span>{intl.formatMessage({ id: langContext + '.fields.client' })}: </span><Text strong>{data?.client?.name}</Text></p>
                    <p>{intl.formatMessage({ id: langContext + '.fields.address' })}</p>
                    <p><Text strong>{data?.client?.address}</Text></p>
                    <p><Text strong>{data?.client?.postal_code} {data?.client?.locality}, {data?.client?.district}</Text></p>
                    <Divider/>
                    <Title level={4}><FormattedMessage id={`reserved-area.construction.title`} /></Title>
                    <p><span>{intl.formatMessage({ id: langContext + '.fields.distance' })}: </span><Text strong>{Core.numeral(data?.distance)}</Text></p>
                    <p><span>{intl.formatMessage({ id: langContext + '.fields.code' })}: </span><Text strong>{data?.service.code}</Text></p>
                    <Divider/>
                    <Title level={4}><FormattedMessage id={`reserved-area.construction.waste.title`} /></Title>
                    <p><span>{intl.formatMessage({ id: langContext + '.fields.service-type' })}: </span><Text strong>{data?.service?.service_type.description[intl.locale.split('-')[0]]}</Text></p>
                    <p><span>{intl.formatMessage({ id: langContext + '.fields.waste-type' })}: </span><Text strong>{data?.service.waste_type?.description[intl.locale.split('-')[0]]}</Text></p>
                    <p><span>{intl.formatMessage({ id: 'components.measurement-unit-select.title' })}: </span><Text strong>{data?.measurement_unit?.description[intl.locale.split('-')[0]]}</Text></p>
                </Modal>
            </>
        </div >
    )
}